import React from "react"
import { makeStyles } from "@material-ui/core/styles"
import Typography from "@material-ui/core/Typography"
import { Accordion, Ref, RichTitle } from "../"

import backgroundImg from "./backgroundImg.svg"
import { FormattedMessage } from "react-intl"

const useStyles = makeStyles(theme => ({
  container: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    alignItems: "center",
  },
  banner: {
    height: "300px",
    zIndex: "1",
    width: "100vw",
    backgroundColor: props =>
      props.heroBannerColor
        ? props.heroBannerColor
        : theme.palette.invertedGreen.support,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
  },
  bannerText: {
    position: "relative",
    margin: theme.spacing(0, 0.5),
    color: theme.palette.green.main,
    fontSize: theme.spacing(5.5),
    letterSpacing: theme.spacing(0.5),
    fontFamily: theme.typography.fontFamily,
    [theme.breakpoints.down("md")]: {
      textAlign: "center",
    },
  },
  backgroundImg: {
    position: "absolute",
    zIndex: "-1",
    width: "350px",
    left: "15%",
    top: theme.spacing(18.1),
    color: "red",
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
  },
  accorContainer: {
    width: "80%",
    maxWidth: theme.spacing(90),
    marginTop: theme.spacing(10),
    position: "relative",
    "& .MuiExpansionPanelSummary-content.Mui-expanded": {
      margin: "12px 0",
    },
    "& .MuiExpansionPanelSummary-root.Mui-expanded": {
      minHeight: "auto",
    },
    "& .MuiPaper-root": {
      marginLeft: 0,
    },
    "& .MuiExpansionPanelSummary-expandIcon.Mui-expanded": {
      transform: "none",
      top: "-4px",
    },
  },
  expansionPanel: {
    boxShadow: "none",
  },
  divider: {
    marginLeft: theme.spacing(3),
    borderTop: "0.5px solid #C3C5C8",
  },
  reference: {
    margin: theme.spacing(10, 0, 2, 3),
  },
  referenceTitle: {
    color: theme.palette.green.main,
    fontWeight: "bold",
  },
  refText: {
    marginLeft: theme.spacing(3),
    width: "90%",
    maxWidth: theme.spacing(80),
  },
}))

const FAQ = props => {
  const classes = useStyles(props)
  const items = props.QAs
  const refItems = props.Refs

  return (
    <div className={classes.container}>
      <div className={classes.banner}>
        <Typography variant={"h1"} classes={{ root: classes.bannerText }}>
          {props.titleText && <RichTitle titleText={props.titleText} />}
        </Typography>
        <img src={backgroundImg} className={classes.backgroundImg} alt="" />
      </div>
      <div className={classes.accorContainer}>
        <hr className={classes.divider} />
        {Object.keys(items).map((QA, index) => (
          <Accordion
            key={index}
            expansionPanel={classes.expansionPanel}
            question={items[QA].question}
            answer={items[QA].answer}
          />
        ))}
        <div className={classes.reference}>
          <Typography className={classes.referenceTitle} variant={"overline"}>
            <FormattedMessage id="refTitle" />
          </Typography>
        </div>
        <div className={classes.refText}>
          {Object.keys(refItems).map((ref, index) => (
            <Ref
              index={index + 1}
              key={index}
              text={refItems[ref].referenceText}
            />
          ))}
        </div>
      </div>
    </div>
  )
}

export default FAQ
